import React from "react";
import EventsListPage from "./EventsListPage";

const PastEvents = ({ events, title }) => {
  return (
    <div>
      <EventsListPage events={events} title={title} />
    </div>
  );
};

export default PastEvents;
